import { render } from "./AdminDashboard.vue?vue&type=template&id=2ed0bf92&scoped=true"
import script from "./AdminDashboard.js?vue&type=script&lang=js&external"
export * from "./AdminDashboard.js?vue&type=script&lang=js&external"

import "./AdminDashboard.vue?vue&type=style&index=0&id=2ed0bf92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed0bf92"]])

export default __exports__